import { AbstractControl } from '@angular/forms';

export class CustomSelectValidator {
    static validateRequiredSelect(control: AbstractControl) {
        if (control.value === '' || !control.value) {
            return { select: { valid: false, messageKey: 'missingSelect' } };
        }
        return null;
    }
}
